<template>
	<div>
		<b-row class="print-row mt-3" v-if="hasArmorUpgrades">
			<b-col>
				<h3 class="avoid-page-break-after">Armor Upgrades</h3>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(upgrade, upgradeID) in usedArmorUpgradeSlots" :key="'details-equipment-armorUgprades-'+upgradeID">
			<b-col cols="2">
				<strong>{{upgrade.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre">
				{{upgrade.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		hasArmorUpgrades: function() {
			return this.$store.getters['character/equipment/hasArmorUpgrades']
		},
		usedArmorUpgradeSlots: function(){
			return this.$store.getters['character/equipment/usedArmorUpgradeSlots']
		}
	}
}
</script>

<style scoped>

</style>